import { useLocation } from 'src/hooks/router/useLocation';

export const useIsOnboarding = () => {
  const location = useLocation();
  const { isOnboarding } = location.state ?? {};
  return isOnboarding;
};
